import script from "./Rules.vue?vue&type=script&setup=true&lang=js"
export * from "./Rules.vue?vue&type=script&setup=true&lang=js"

import "./Rules.vue?vue&type=style&index=0&id=34066507&lang=scss"

const __exports__ = script;

export default __exports__